import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const regionAPI = createApi({
    reducerPath: "regionAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllZonesWithoutPage: builder.mutation({
            query: () => {
                let apiUrl = `admin/data/zone`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["zone_list"],
        }),
        getAllZones: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/zone?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["zone"],
        }),
        createZone: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/zone",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["zone"],
        }),
        updateZone: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/zone`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["zone"],
        }),
        getAllZonesAssignedDeliveryPersons: builder.mutation({
            query: ({zoneId}) => {
                let apiUrl = `admin/zone/${zoneId}/delivery-person`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        assignDeliveryPersonToZone: builder.mutation({
            query: ({ zoneId, data }) => {
                let apiUrl = `admin/zone/${zoneId}/delivery-person`;

                return {
                    url: apiUrl,
                    method: "POST",
                    body: data
                };
            },
            transformResponse: (response) => response
        }),


        getAllCities: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/city?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["city"],
        }),
        createCity: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/city",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["city"],
        }),
        updateCity: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/city`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["city"],
        })
    })
});

export const { 
    useGetAllZonesWithoutPageMutation,
    useGetAllZonesMutation,
    useCreateZoneMutation,
    useUpdateZoneMutation,
    useGetAllZonesAssignedDeliveryPersonsMutation,
    useAssignDeliveryPersonToZoneMutation,

    useGetAllCitiesMutation,
    useCreateCityMutation,
    useUpdateCityMutation
} = regionAPI;

export default regionAPI;